var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistorical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.593 3.217H4.698C4.18169 3.21752 3.68667 3.42279 3.32149 3.78778C2.95632 4.15277 2.75079 4.64769 2.75 5.164V18.797C2.75 19.872 3.622 20.744 4.698 20.744H8.593C9.10913 20.7432 9.6039 20.5378 9.96886 20.1729C10.3338 19.8079 10.5392 19.3131 10.54 18.797V5.164C10.5392 4.64786 10.3338 4.1531 9.96886 3.78813C9.6039 3.42317 9.10913 3.21779 8.593 3.217Z",
    stroke: "#28325A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.54 7.92999L13.656 19.615C13.7911 20.113 14.1181 20.5371 14.5653 20.7944C15.0126 21.0518 15.5435 21.1214 16.042 20.988L19.81 20.014C20.3084 19.8796 20.733 19.5527 20.9905 19.1053C21.2479 18.6578 21.3172 18.1265 21.183 17.628L17.658 4.38499C17.5235 3.88658 17.1967 3.46197 16.7492 3.2045C16.3018 2.94703 15.7705 2.87779 15.272 3.01199L11.514 4.01499C11.108 4.12599 10.75 4.36499 10.491 4.69699M6.64498 17.379C7.04373 17.379 7.42615 17.2206 7.70811 16.9386C7.99008 16.6567 8.14848 16.2742 8.14848 15.8755C8.14848 15.4767 7.99008 15.0943 7.70811 14.8124C7.42615 14.5304 7.04373 14.372 6.64498 14.372C6.24623 14.372 5.86381 14.5304 5.58184 14.8124C5.29988 15.0943 5.14148 15.4767 5.14148 15.8755C5.14148 16.2742 5.29988 16.6567 5.58184 16.9386C5.86381 17.2206 6.24623 17.379 6.64498 17.379Z",
    stroke: "#28325A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.665 17.241C17.0633 17.241 17.4454 17.0828 17.727 16.8011C18.0087 16.5194 18.167 16.1374 18.167 15.739C18.167 15.3406 18.0087 14.9586 17.727 14.6769C17.4454 14.3952 17.0633 14.237 16.665 14.237C16.2666 14.237 15.8846 14.3952 15.6029 14.6769C15.3212 14.9586 15.163 15.3406 15.163 15.739C15.163 16.1374 15.3212 16.5194 15.6029 16.8011C15.8846 17.0828 16.2666 17.241 16.665 17.241Z",
    stroke: "#28325A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorical);
export default __webpack_public_path__ + "static/media/historical.4fa16d0b21a0110e703b57383600cdec.svg";
export { ForwardRef as ReactComponent };